import React, { useState, useEffect } from 'react';
import {
  Box, CircularProgress, Typography, Paper, Alert, Button
} from '@mui/material';
import { getThing, startThingUpdatesNoJourney, stopUpdates } from './LiveApis';
import Openlayer from './openlayer';

function Live_SingleTrack() {
  const [thingModel, setThingModel] = useState(null);
  const [error, setError] = useState(null);
  const [currentLocation, setCurrentLocation] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  // -----------------------------------------------------------------
  // 1. Load thing + start real-time updates
  // -----------------------------------------------------------------
  useEffect(() => {
    const authParams = new URLSearchParams(window.location.search);

    getThing(
      data => {
        setThingModel(data);
        setError(null);
        if (data.latest?.GPS?.location) setCurrentLocation(data.latest.GPS.location);
        startThingUpdatesNoJourney(loc => setCurrentLocation(loc));
      },
      err => setError(err)
    );

    const timer = setTimeout(() => setIsLoading(true), 5000);
    return () => {
      clearTimeout(timer);
      stopUpdates();
    };
  }, []);

  // -----------------------------------------------------------------
  // 2. UI
  // -----------------------------------------------------------------
  if (thingModel === null && error === null && !isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
        <CircularProgress />
        <Typography ml={2}>Loading tracker...</Typography>
      </Box>
    );
  }

  if (thingModel === null && error === null && isLoading) {
    return (
      <Paper elevation={3} sx={{ p: 3, textAlign: 'center', mt: 4 }}>
        <Typography variant="h6" gutterBottom>
          If loading takes too long,
        </Typography>
        <Button variant="contained" onClick={() => window.location.reload()} sx={{ mt: 2 }}>
          Refresh
        </Button>
      </Paper>
    );
  }

  if (error) {
    return (
      <Alert severity="error" sx={{ mt: 2 }}>
        <Typography>{error}</Typography>
        <Button
          size="small"
          onClick={() => window.location.reload()}
          sx={{ mt: 1 }}
        >
          Refresh
        </Button>
      </Alert>
    );
  }

  // -----------------------------------------------------------------
  // 3. Only the map with the live vehicle
  // -----------------------------------------------------------------
  return (
    <Box sx={{ width: '100%', py: 2 }}>
      <Paper elevation={2} sx={{ position: 'relative', overflow: 'hidden', borderRadius: 2 }}>
        <Openlayer position={currentLocation} />
      </Paper>
    </Box>
  );
}

export default Live_SingleTrack;